// Deploys serve the admin from a commit-hash subpath (moon.yml's build-vite passes
// --base /$IMAGE_TAG/), so a root-absolute '/file.svg' resolves against the domain
// root and misses the deployed asset.
export const publicAssetUrl = (fileName: string): string => `${import.meta.env.BASE_URL}${fileName}`
